/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var domService = require('./dom.service');
var formService = require('./form.service');
var paymentApi = require('./payment-api.service');
var paymentLayout = require('./payment-option-layout.service');
var networkServices = require('./networks.service');
var handleServiceError = require('./handle-error.service');
var groupService = require('./group.service');
var opTemplateEngine = require('op-template-engine');
var listRequest = require('../list/list-request');
var translate = require('./translate.service');
var rootScope = require('./root-scope.service');

function reInit() {
    listRequest();
}

function handleAccountSelection(account) {
    formService.handleNetworkSelection(account);
}

function bindAccountClick() {
    $(document).on('click', domService.getAllAccountsButton(), function (event) {
        event.stopPropagation();
        if ($(this).attr('value') === rootScope.getSelectedNetworkCode()) {
            return;
        }
        handleAccountSelection(rootScope.getAllAccounts()[$(this).attr('data-id')]);
        paymentLayout.toggleIcons(rootScope.getSelectedNetworkCode(), rootScope.isSmartSwitch());
        paymentLayout.addSelectedToLi($(this));
    });
}

function bindPresetAccountClick() {
    $(document).on('click', domService.getPresetAccountButton(), function () {
        if ($(this).attr('value') === rootScope.getSelectedNetworkCode()) {
            return;
        }
        handleAccountSelection(rootScope.getPresetAccount());
        paymentLayout.toggleIcons('preset', rootScope.isSmartSwitch());
        paymentLayout.addSelectedToLi($(this));
    });
}

function bindNetworkClick() {
    $(document).on('click', domService.getAllNetworksButton(), function (event) {
        event.stopPropagation();
        var currentValue = $(this).attr('value');
        var networks = rootScope.getAllNetworks();
        var selectedCode = rootScope.getSelectedNetworkCode();
        if (currentValue === selectedCode || groupService.getGroup(selectedCode, networks) === currentValue) {
            return;
        }
        paymentLayout.addSelectedToLi($(this));
        var autoSelectedNetwork;
        var inputValue = $(this).val();

        //if smart switch and already loaded to take the switched form by default
        if (
            networks[inputValue] &&
            networks[inputValue].length > 1 &&
            $(this).closest('.available-network').hasClass('grouped-smart-network')
        ) {
            var loadedCode;
            if ($('#formContainer' + networks[inputValue][0].networkCode + ' .form').length > 0) {
                var loadedFromId = $('#formContainer' + networks[inputValue][0].networkCode)
                    .find('.form')
                    .attr('id');
                loadedCode = loadedFromId.substring(0, loadedFromId.lastIndexOf('form'));
                autoSelectedNetwork = networkServices.getNetworkByCode(networks, loadedCode);
            } else if ($('#formContainer' + networks[inputValue][0].networkCode + ' iframe[data-loaded]').length > 0) {
                loadedCode = $('#formContainer' + networks[inputValue][0].networkCode)
                    .find('iframe')
                    .attr('data-loaded');
                autoSelectedNetwork = networkServices.getNetworkByCode(networks, loadedCode);
            } else {
                autoSelectedNetwork = networks[inputValue][0];
            }
        } else {
            autoSelectedNetwork = networks[inputValue][0];
            if ($(this).closest('.available-network').hasClass('grouped-network')) {
                // set first selected choice in drop-down
                $('.select-' + inputValue).val(networks[inputValue][0].networkCode);
            }
        }
        formService.handleNetworkSelection(autoSelectedNetwork);

        paymentLayout.toggleIcons(autoSelectedNetwork.networkCode, rootScope.isSmartSwitch());
        //grouped network but not loaded yet
        if (
            networks[inputValue].length > 1 &&
            $(this).closest('.available-network').hasClass('grouped-network') &&
            $('#formContainer' + networks[inputValue][0].networkCode).length === 0
        ) {
            formService.preloadGroupedNetworks(networks[inputValue]);
        }
    });
    //grouped but not smart-switch labels
    $(document).on('click', domService.getAllGroupedNetworkLabel(), function () {
        event.stopPropagation();
        var networks = rootScope.getAllNetworks();
        var label = $(this);
        // select the radio button
        $('#paymentType' + label.attr('data-type')).prop('checked', true);
        // set selected choice in drop-down
        $('.select-' + label.attr('data-type')).val(label.attr('data-code'));
        var clickedNetwork = networks[label.attr('data-type')][label.attr('data-id')];
        //blur all other icons
        paymentLayout.toggleIcons(clickedNetwork.networkCode, rootScope.isSmartSwitch());
        // show related form
        formService.handleNetworkSelection(clickedNetwork);
    });
    $(document).on('change', domService.getAllGroupedNetworkSelect(), function (event) {
        event.stopPropagation();
        var networks = rootScope.getAllNetworks();
        var select = $(this);
        //get index of network in group
        var indexInGroup = select[0].selectedIndex - 1 > 0 ? select[0].selectedIndex - 1 : 0;
        //update select box choice. if none selected, select first
        select.prop('selectedIndex', indexInGroup + 1);
        //check the radio button
        $('#paymentType' + select.attr('data-type')).prop('checked', true);
        var clickedNetwork = networks[select.attr('data-type')][indexInGroup];
        //toggle icons
        paymentLayout.toggleIcons(clickedNetwork.networkCode, rootScope.isSmartSwitch());
        //handle selection of network
        formService.handleNetworkSelection(clickedNetwork);
    });
}

function bindDeleteClick() {
    $(document).on('click', '.registered-account-update .delete-account', function (event) {
        var dataId = $(this).attr('data-id');
        event.stopPropagation();
        showConfirmDeleteText();
        $('#submit-delete').attr('data-id', dataId);

        $('#confirmDeletePage').css('display', 'table');
    });

    function makeDelete(element, callback) {
        paymentApi.deleteAccount(createDeleteUrl(element), callback);
    }

    $(document).on('click', '.submit-delete-button, .delete-account-submit', function (event) {
        event.stopPropagation();
        var element = $(this);
        makeDelete(element, deleteAccountCallback);
    });
    $(document).on('click', '.cancel-delete', function (event) {
        event.stopPropagation();
        $('#confirmDeletePage').hide();
    });

    function createDeleteUrl() {
        var selectedNetwork = rootScope.getSelectedNetwork();

        return selectedNetwork.links.self;
    }

    function showConfirmDeleteText() {
        var selectedAccount = rootScope.getSelectedNetwork();
        var displayLabel = '';
        if (selectedAccount.networkCode === 'preset') {
            displayLabel = selectedAccount.networkCode;
        } else {
            if (selectedAccount.maskedAccount && selectedAccount.maskedAccount.displayLabel) {
                var maskedAccountObj = selectedAccount.maskedAccount.displayLabel;
                displayLabel = maskedAccountObj.beginning + maskedAccountObj.stars + maskedAccountObj.ending;
            }
        }
        var data = {
            'account.displayLabel': displayLabel,
        };
        $('#confirmDeletePage p').html(opTemplateEngine(translate('accounts.delete.text'), data, '', false));
        $('#confirmDeletePage h2').html(translate('accounts.delete.title'));
    }

    function deleteAccountCallback(err, data) {
        if (err) {
            return handleServiceError(err);
        }

        if (data.interaction.code === 'RELOAD') {
            $('#confirmDeletePage').hide();
            rootScope.getListContainer().html('');
            reInit();
        } else {
            $('#confirmDeletePage').hide();
        }
    }
}

function bindAccountSelection() {
    $(domService.getButtonClass()).on('keypress', function (event) {
        if (event && typeof event === 'object' && ((event.code && event.code === 'Enter') || (event.keyCode && event.keyCode === 13)))
            $(event.target).find('input:radio.payment-option-radio').trigger('click');
    });
}

module.exports = {
    bindAccountClick: bindAccountClick,
    bindDeleteClick: bindDeleteClick,
    bindNetworkClick: bindNetworkClick,
    bindPresetAccountClick: bindPresetAccountClick,
    bindAccountSelection: bindAccountSelection,
};
